import { gql } from '@apollo/client';

export const ALL_COURSE_TAGS_QUERY = gql`
    query courses {
        courses {
            edges {
                node {
                    id
                    tags
                }
            }
        }
    }
`;
